import React, { useEffect } from 'react';
import CacheBuster from 'react-cache-buster';
import Loading from './pages/Loading';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import {
	Chart,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ArcElement,
	LineElement,
	PointElement,
	Filler
} from 'chart.js';

import { RouterProvider } from 'react-router';
import { router } from './routes/routes';
import {
	ThemeProvider,
	StyledEngineProvider,
	createTheme,
	responsiveFontSizes
} from '@mui/material/styles';

import 'moment/locale/ro';

import { connect } from 'react-redux';
import { StreakProvider } from './contexts/StreakContext';
import MetaPixel from './tracking/metaPixel';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleOAuthProvider } from '@react-oauth/google';
import TikTokPixel from './tracking/tikTokPixel';

Chart.register(
	Filler,
	CategoryScale,
	LineElement,
	PointElement,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ArcElement
);

function App({ theme }) {
	const googleClientId = '765696322605-nfodd2lgmcbbouqc4uj9c1tb3jllqkhv.apps.googleusercontent.com';

	let themeConfig = createTheme(theme);
	themeConfig = responsiveFontSizes(themeConfig);

	// Function to set the custom --vh CSS variable
	const setViewportHeight = () => {
		const vh = window.innerHeight * 0.01; // Calculate 1vh
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	};

	useEffect(() => {
		// Set the viewport height on mount
		setViewportHeight();

		// Update the viewport height on window resize
		window.addEventListener('resize', setViewportHeight);

		// Clean up the event listener on unmount
		return () => {
			window.removeEventListener('resize', setViewportHeight);
		};
	}, []);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const fbclid = urlParams.get('fbclid');
		const ttclid = urlParams.get('ttclid');

		if (fbclid) {
			localStorage.setItem('fbclid', fbclid);
			document.cookie = `fbclid=${fbclid};path=/;max-age=2592000`;
		}
		if (ttclid) {
			localStorage.setItem('ttclid', ttclid);
			document.cookie = `ttclid=${ttclid};path=/;max-age=2592000`;
		}
	}, []);

	return (
		<CacheBuster
			currentVersion={process.env.REACT_APP_VERSION}
			isEnabled={process.env.NODE_ENV === 'production'} // If false, the library is disabled.
			isVerboseMode={false} // If true, the library writes verbose logs to console.
			loadingComponent={<Loading />} // If not pass, nothing appears at the time of new version check.
			metaFileDirectory={'.'} // If public assets are hosted somewhere other than root on your server.
			onCacheClear={() => {}}
		>
			<GoogleOAuthProvider clientId={googleClientId}>
				<SubscriptionProvider>
					<StreakProvider>
						<StyledEngineProvider injectFirst>
							<ThemeProvider theme={themeConfig}>
								<CssBaseline />
								<MetaPixel />
								<TikTokPixel />
								<RouterProvider router={router} />
							</ThemeProvider>
						</StyledEngineProvider>
					</StreakProvider>
				</SubscriptionProvider>
			</GoogleOAuthProvider>
		</CacheBuster>
	);
}

const mapStateToProps = (state) => ({
	theme: state.theme
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
